import React, { useRef } from '../../../_snowpack/pkg/react.js';
import PropTypes from '../../../_snowpack/pkg/prop-types.js';
import { useDrag, useDrop } from '../../../_snowpack/pkg/react-dnd.js';
import throttle from '../../../_snowpack/pkg/lodash/throttle.js';
import { useMediasDnDContext, MediasDndEvents } from './index.js';
import { hover } from './drag.helpers.js';
const hoverThrottled = throttle(hover, 50);
const lastOffset = {
  x: 0,
  y: 0
};
/**
 * Component that Wraps the element to be draggable and droppable
 */

function Drag({
  children,
  type,
  index,
  item,
  parentId,
  reorderItems,
  insertItem,
  removeItem
}) {
  let ref = useRef(null);
  const dndContext = useMediasDnDContext();
  const [, drag] = useDrag({
    type,
    item: () => {
      dndContext.setActive(true);
      return {
        item,
        index,
        parentId,
        originalIndex: index,
        originalParentId: parentId,
        remove: () => removeItem(item.id)
      };
    },
    end: (item, monitor) => {
      dndContext.setActive(false);
      document.activeElement.blur();
      const dropResult = monitor.getDropResult();

      if ((dropResult === null || dropResult === void 0 ? void 0 : dropResult.dropEffect) === 'copy') {
        MediasDndEvents.emit('insertCopyItem', {
          item: item.item,
          index: item.originalIndex,
          parentId: item.originalParentId
        });
      }
    }
  });
  const [, drop] = useDrop({
    accept: type,
    hover: (item, monitor) => {
      const offset = monitor.getClientOffset();

      if (Math.abs(offset.x - lastOffset.x) > 5 || Math.abs(offset.y - lastOffset.y) > 5) {
        Object.assign(lastOffset, offset);
        hoverThrottled({
          item,
          index,
          parentId,
          reorderItems,
          insertItem,
          removeItem
        });
      }
    }
  });
  drag(drop(ref));
  return React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    ref
  }));
}

Drag.propTypes = {
  children: PropTypes.node,

  /**
   * Index of the element rendered.
   */
  index: PropTypes.number.isRequired,

  /**
   * Object like containing the information about the item
   */
  item: PropTypes.object.isRequired,

  /**
   * Unique ID for each drop container
   */
  parentId: PropTypes.string.isRequired,

  /**
   * Callback to call when sorting within a container is happening
   */
  reorderItems: PropTypes.func.isRequired,

  /**
   * Type of the draggable item, this is what allow to drop in
   * container that accept this type of items
   */
  type: PropTypes.string.isRequired
};
export default Drag;